import { Box } from '@mui/material';
import React from 'react';

import EditArtworkAudio from '../EditArtworkAudio';
import EditArtworkEdition from '../EditArtworkEdition';
import EditArtworkImages from '../EditArtworkImages';
import EditArtworkInfo from '../EditArtworkInfo';

const EditArtworkDetailBlock = ({ artworkFormState, artwork, isArtist }) => {
  return (
    <Box>
      <EditArtworkEdition artworkFormState={artworkFormState} />
      <EditArtworkInfo
        artworkFormState={artworkFormState}
        artwork={artwork}
      />
      <EditArtworkImages artworkFormState={artworkFormState} />
      {isArtist && (
        <EditArtworkAudio
          artworkFormState={artworkFormState}
          isArtist={isArtist}
        />
      )}
    </Box>
  );
};

export default EditArtworkDetailBlock;
